import { formatDate } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-create-quotes',
  templateUrl: './create-quotes.component.html',
  styleUrls: ['./create-quotes.component.css']
})
export class CreateQuotesComponent {
  
  quoteForm!: FormGroup;
  basicForm!: FormGroup;
  addressForm!: FormGroup;
  financialForm!: FormGroup;
   currentDate = new Date();
  
    cValue = formatDate(this.currentDate, 'yyyy-MM-dd', 'en-US');
  
  constructor(
    private fb: FormBuilder,
 
  ) {}

  ngOnInit() {
    this.quoteForm = this.fb.group({
      // 🔹 Basic Details
      title: ['', [Validators.required, Validators.maxLength(100)]],
      quoteNumber: ['', [Validators.pattern(/^[A-Z0-9\-]+$/)]],
      validUntil: ['', Validators.required],
      assignedTo: ['', Validators.maxLength(100)],
      approvalStatus: [''],
      opportunity: ['', Validators.maxLength(150)],
      quoteStage: ['Draft', Validators.required],
      invoiceStatus: ['Not Invoiced'],
      paymentTerms: ['', Validators.maxLength(100)],
      approvalIssues: ['', Validators.maxLength(500)],
    
      // 🔹 Address Info
      account: ['', Validators.maxLength(100)],
      contact: ['', Validators.maxLength(100)],
    
      billingAddress: this.fb.group({
        street: ['', Validators.maxLength(100)],
        city: ['', Validators.maxLength(50)],
        state: ['', Validators.maxLength(50)],
        postalCode: ['', [Validators.pattern(/^\d{5,10}$/)]],
        country: ['', Validators.maxLength(50)]
      }),
    
      shippingAddress: this.fb.group({
        street: ['', Validators.maxLength(100)],
        city: ['', Validators.maxLength(50)],
        state: ['', Validators.maxLength(50)],
        postalCode: ['', [Validators.pattern(/^\d{5,10}$/)]],
        country: ['', Validators.maxLength(50)]
      }),
    
      // 🔹 Financial Info
      currency: ['USD', Validators.required],
      total: ['', [Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
      discount: ['', [Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
      subtotal: ['', [Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
      shipping: ['', [Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
      shippingTax: ['0', Validators.required],
      tax: ['', [Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
      grandTotal: ['', [Validators.pattern(/^\d+(\.\d{1,2})?$/)]]
    });
    this.basicForm = this.fb.group({
      title: ['', [Validators.required, Validators.maxLength(100)]],
      quoteNumber: ['', [Validators.pattern(/^[A-Z0-9\-]+$/)]],
      validUntil: ['', Validators.required],
      assignedTo: ['', Validators.maxLength(100)],
      approvalStatus: [''],
      opportunity: ['', Validators.maxLength(150)],
      quoteStage: ['Draft', Validators.required],
      invoiceStatus: ['Not Invoiced'],
      paymentTerms: ['', Validators.maxLength(100)],
      approvalIssues: ['', Validators.maxLength(500)]
    });
    this.addressForm = this.fb.group({
      account: ['', Validators.maxLength(100)],
      contact: ['', Validators.maxLength(100)],
      billingAddress: this.fb.group({
        street: ['', Validators.maxLength(100)],
        city: ['', Validators.maxLength(50)],
        state: ['', Validators.maxLength(50)],
        postalCode: ['', [Validators.pattern(/^\d{5,10}$/)]],
        country: ['', Validators.maxLength(50)]
      })
    });
    this.financialForm = this.fb.group({
      currency: ['USD', Validators.required],
      total: ['', [Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
      discount: ['', [Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
      subtotal: ['', [Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
      shipping: ['', [Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
      shippingTax: ['0', Validators.required],
      tax: ['', [Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
      grandTotal: ['', [Validators.pattern(/^\d+(\.\d{1,2})?$/)]]
    });
    
    
    
    //   title: ['', Validators.required],
    //   quoteNumber: [''],
    //   validUntil: [new Date().toISOString().substring(0, 10), Validators.required],
    //   assignedTo: [''],
    //   approvalStatus: [''],
    //   opportunity: [''],
    //   quoteStage: ['Draft', Validators.required],
    //   invoiceStatus: ['Not Invoiced'],
    //   paymentTerms: [''],
    //   approvalIssues: [''],

    //   // Address Information
    //   account: [''],
    //   contact: [''],
    //   billingAddress: this.fb.group({
    //     street: [''],
    //     city: [''],
    //     state: [''],
    //     postalCode: [''],
    //     country: ['']
    //   }),
    //   shippingAddress: this.fb.group({
    //     street: [''],
    //     city: [''],
    //     state: [''],
    //     postalCode: [''],
    //     country: ['']
    //   }),

    //   // Financial Info
    //   currency: ['USD'],
    //   total: [''],
    //   discount: [''],
    //   subtotal: [''],
    //   shipping: [''],
    //   shippingTax: ['0'],
    //   tax: [''],
    //   grandTotal: ['']
    // });
  }
  onSubmit() {
    if (this.quoteForm.valid) {
      console.log('Form Submitted:', this.quoteForm.value);
    }
  }
}

